import { define } from 'wicked-elements'
import L from 'leaflet'
import 'leaflet.markercluster'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
const isTouch = window.matchMedia('(hover: none)')

define('[data-component~="plotted-map"]', {
  init () {
    try {
      this.locations = JSON.parse(this.element.dataset.locations)
    } catch (e) {
      this.locations = []
    }

    this.zoom = this.element.dataset.zoom || 5
    
    this.center = this.element.dataset.center
      ? this.element.dataset.center.split(',')
      : [39.8090803, -98.5599219] // Center of USA (Lebanon, Kansas)
    
    this.initMap()
  },
  initMap () {
    // Init map with center & zoom
    this.map = L.map(this.element, {
      scrollWheelZoom: false,
      zoomControl: false
    }).setView(this.center, this.zoom)

    // Add tile layer to map
    this.tiles = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(this.map)

    // Create cluster group
    this.clusterGroup = L.markerClusterGroup({
      polygonOptions: { // EDIT: cluster polygon options
        fillColor: '#fff',
        color: '#000',
        weight: 1,
        opacity: 1,
        dashArray: [5, 5],
        fillOpacity: 0
      },
      iconCreateFunction: function (cluster) {
        return L.divIcon({
          html: cluster.getChildCount(),
          className: 'mapcomponent-cluster-icon', // cluster marker icon
          iconSize: [32, 32] // EDIT: cluster marker size
        })
      }
    })

    // Create a marker for each location, and add to cluster group
    this.customMarkerIcon = this.createCustomMarkerIcon()
    this.locations.forEach(location => {
      const marker = this.createMarker(location)
      this.clusterGroup.addLayer(marker)
    })

    // Fit map to points
    this.fitBounds()

    // Add cluster group to map
    this.clusterGroup.addTo(this.map)

    // Add zoom control to bottom right
    this.zoomControl = new L.Control.Zoom({ position: 'bottomright' }).addTo(this.map)
    
    // Remove `href` from zoom controls
    const $controlElement = this.zoomControl.getContainer()
    const $zoomControls = [...$controlElement.querySelectorAll(`a[href="#"]`)]
    $zoomControls.forEach(el => el.removeAttribute('href'))
  },
  fitBounds () {
    if (!this.clusterGroup) return
    // This automatically handles the case of a single point by centering on it at max zoom (this.state.zoom)
    this.map.fitBounds(
      this.clusterGroup.getBounds(),
      {
        maxZoom: 19,
        padding: [20, 20],
        animate: false
      }
    )
  },
  createCustomMarkerIcon () {
    return L.divIcon({
      className: 'mapcomponent-marker',
      iconSize: [16, 16]
    })
  },
  createMarker (data) {
    const marker = L.marker(new L.LatLng(data.lat, data.lng), { 
      icon: this.customMarkerIcon 
    })

    this.createTooltip(marker, data)

    return marker
  },
  createTooltip (marker, data) {
    marker.bindPopup(`<a href="${data.link}" class="text-accent">${data.title}</a>`, {
      className: 'mapcomponent-popup', // custom className for popup
      maxWidth: Math.min(240, window.innerWidth - 20), // EDIT: popup maxWidth
      // offset: L.point(0, -10), // EDIT: popup offset
      closeButton: false
    })

    if (isTouch.matches) {
      return
    }
  
    marker.on('mouseover', function (e) {
      this.openPopup()
    })

    // this could be better, allows to hover over tooltips
    marker.on('mouseout', function (e) {
      var popupElement = this._popup.getElement()
      if (!popupElement) return
      var inElement = false
      
      function setInElement () {
        inElement = true
      }

      var closePopup = function () {
        this.closePopup()
        popupElement.removeEventListener('mouseenter', setInElement)
        popupElement.removeEventListener('mouseleave', closePopup)
      }.bind(this)

      popupElement.addEventListener('mouseenter', setInElement)
      popupElement.addEventListener('mouseleave', closePopup)

      setTimeout(function () {
        if (!inElement) {
          this.closePopup()
          popupElement.removeEventListener('mouseenter', setInElement)
          popupElement.removeEventListener('mouseleave', closePopup)
        }
      }.bind(this), 300)
    })

    marker.off('click')
  },
  connected () {
    
  },
  disconnected () {
    
  }
})